import Hammer from 'hammerjs';
import {Utils} from 'common/scripts/utils';

class SalePopup {
    constructor() {
        this.wrapper = null;
        this.content = null;

        // Кнопка вызова попапа
        this.button = null;

        // Попап
        this.popup = null;

        // Оверлей
        this.overlay = null;

        // Кнопка закрытия попапа
        this.closeButton = null;

        this.activeClass = 'is-active';
        this.animationClass = 'is-animate';

        this.animationTime = 300;
        this.isMobile = Utils.isMobile();
        this.state = 'close';

        this._bindMethodsContext();
    }

    init(wrapper) {
        this.wrapper = wrapper;
        this.content = this.wrapper.querySelector('.j-sale-content');
        this.button = this.wrapper.querySelector('.j-sale-button');
        this.overlay = this.wrapper.querySelector('.j-sale-overlay');
        this.closeButton = this.wrapper.querySelector('.j-sale-close');

        this._bindEvents();
        // если в this.content лежит null, то падают все попапы
        if (this.content) {
            this._bindHammerJs();
        }
    }

    _bindMethodsContext() {
        this._closeByKeyboard = this._closeByKeyboard.bind(this);
    }

    _bindEvents() {
        this.button.addEventListener('click', this._openPopup.bind(this));

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this._closePopup.bind(this));
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', this._closePopup.bind(this));
        }

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                if (this.isMobile && !Utils.isMobile() && this.state === 'open') {
                    this._closePopup();
                }
            });
        });
    }

    _bindHammerJs() {
        this.hammerjs = new Hammer(this.content);
        this.hammerjs.get('swipe').set({direction: Hammer.DIRECTION_ALL});
        this.hammerjs.on('swipedown', this._closePopup.bind(this));
    }

    _openPopup() {
        this.wrapper.classList.add(this.activeClass, this.animationClass);
        this.state = 'open';
        Utils.bodyFixed(this.wrapper);
        document.addEventListener('keyup', this._closeByKeyboard);
    }

    _closeByKeyboard(key) {
        const keyCodeESC = 27;

        if (key.keyCode === keyCodeESC) {
            this._closePopup();
        }
    }

    _closePopup() {
        this.wrapper.classList.remove(this.animationClass);
        setTimeout(() => {
            this.wrapper.classList.remove(this.activeClass);
        }, this.animationTime);
        document.removeEventListener('keyup', this._closeByKeyboard);
        this.state = 'close';
        Utils.bodyStatic();
    }
}

export default SalePopup;
